export function markInvalidAttribute (attributeName, errorMessage) {
	displayInvalidBorder($(attributeName))
	displayInvalidTooltip($(attributeName), errorMessage)
}

export function markInvalidAttributeGrops () {
	$('#groups').find('a').removeClass('invalid-attribute-group')
	_.each($('.tab-content').find('.tab-pane'), function (tab) {
		if ($(tab).find('.invalid-attribute').length != 0) {
			$('#groups').find('a[href=\'#' + $(tab).attr('id') + '\']').addClass('invalid-attribute-group')
		}
	})
}

function displayInvalidBorder (attribute) {
	$(attribute).addClass('invalid-attribute')
	$(attribute).bind('focusout', function () {
		removeInvalidAttributeMark($(attribute))
	})
}

function displayInvalidTooltip (attribute, error) {
	$(attribute).tooltip({
		placement: 'bottom',
		container: '.form',
		title: error
	})
}

export function removeInvalidAttributeMark (attribute) {
	$(attribute).removeClass('invalid-attribute')
	$(attribute).tooltip('destroy')
}
